import { useState } from 'react';

const useStaffAugmentationState = () => {
  const [rows, setRows] = useState([]);
  const [listStaffAugData, setListStaffAugData] = useState([]);
  const [isMobileView, setIsMobileView] = useState(false);
  const [isLaptopView, setIsLaptopView] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isCopy, setIsCopy] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [statusOptions, setStatusOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [employeeNameOptions, setEmployeeNameOptions] = useState([]);
  const [employeeIdOptions, setEmployeeIdOptions] = useState([]);
  const [deleteStaffAugmentationDialog, setDeleteStaffAugmentationDialog]
    = useState(false);
  const [staffAugmentationId, setStaffAugmentationId] = useState(null);
  const [addRequirementOpen, setAddRequirementOpen] = useState(false);
  const [staffAugFilterValues, setStaffAugFilterValues] = useState({
    project: [],
    status: [],
    employeeName: [],
    employeeId: [],
  });
  const [editStaffData, setEditStaffData] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [isPdfHovered, setIsPdfHovered] = useState(false);
  const [isExcelHovered, setIsExcelHovered] = useState(false);
  const [jobDescView, setJobDescView] = useState(false);
  const [jobDescFileUrl, setJobDescFileUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  return {
    rows,
    isMobileView,
    isLaptopView,
    isEdit,
    isCopy,
    currentPage,
    statusOptions,
    projectOptions,
    employeeNameOptions,
    employeeIdOptions,
    deleteStaffAugmentationDialog,
    staffAugmentationId,
    staffAugFilterValues,
    listStaffAugData,
    addRequirementOpen,
    editStaffData,
    anchorEl,
    isPdfHovered,
    isExcelHovered,
    jobDescView,
    jobDescFileUrl,
    isLoading,
    setRows,
    setIsMobileView,
    setIsLaptopView,
    setIsEdit,
    setIsCopy,
    setCurrentPage,
    setStatusOptions,
    setProjectOptions,
    setEmployeeNameOptions,
    setEmployeeIdOptions,
    setDeleteStaffAugmentationDialog,
    setStaffAugmentationId,
    setStaffAugFilterValues,
    setListStaffAugData,
    setAddRequirementOpen,
    setEditStaffData,
    setAnchorEl,
    setIsPdfHovered,
    setIsExcelHovered,
    setJobDescView,
    setJobDescFileUrl,
    setIsLoading,
  };
};

export default useStaffAugmentationState;
